import { PortableTextReactComponents } from "@portabletext/react";
import React, { ReactElement } from "react";
import { InlineImage } from "./InlineImage";
import styles from "./components.module.scss";

export type PlaceholderResolver = (placeholder: string[]) => ReactElement;
const defaultPlaceholderResolver = (k) => k;

// WARNING: extra React.Fragment are needed to solve the google chrome translation issue
export const defaultComponents = (
  placeholderResolver = defaultPlaceholderResolver
): Partial<PortableTextReactComponents> => ({
  marks: {
    placeholderResolver: placeholderResolver,
    placeholder: ({ children }: { children }) => (
      <React.Fragment>{children}</React.Fragment>
    ),
    sup: ({ children }: { children }) => <sup>{children}</sup>,
    sub: ({ children }: { children }) => <sub>{children}</sub>,
    link: ({ value, children }) => (
      // eslint-disable-next-line react/jsx-no-target-blank
      <a
        href={value.href}
        target={value.openInNewTab ? "_blank" : undefined}
        rel={value.openInNewTab ? "noopener noreferrer" : undefined}
      >
        {children}
      </a>
    )
  },
  types: {
    inlineImage: ({ value }) => {
      if (value) return <InlineImage {...value} />;
      return null;
    },
    imageWithAlign: ({ value }) => {
      //deprecated
      if (value) return <InlineImage {...value} />;
      return null;
    }
  },
  block: {
    disclaimer: ({ children }) => <small>{children}</small>,
    "text-1-5x": ({ children }) => (
      <span className={styles.text15}>{children}</span>
    )
  }
});
